import React from 'react';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { shallowEqual, useSelector } from 'react-redux';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { useMaskPII } from 'hooks/useMaskPII';
import { useNavigation } from 'hooks/useNavigation';
import NsContent from 'components/common/ns-content/NsContent';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsColumn } from '@britishgasenergy/react-nucleus';
import { EnergyHelp } from 'components/direct-sales/quote/components/EnergyHelp';
import MoreInformation from 'components/direct-sales/quote/components/MoreInformation';
import { DirectDebitPromotionExpander } from 'components/direct-sales/quote/components/DirectDebitPromotionExpander';

export const testId = 'quoteExpiredTestId';

const QuoteExpiredContent: React.FC = () => {
  const { next, eventTypes } = useNavigation();
  const { mask } = useMaskPII();

  const address = useSelector(selectedAddress, shallowEqual);

  const handleNext = () => {
    next({eventType: eventTypes.NEXT});
  }

  return (
    <>
      <NsPanel testId={testId} decoration="grey-light">
        <NsColumn hockeypitch="2:1">
          <NsContent>
            <h5 className="p-small">
              <strong>
                Quote for{' '}
                <span {...mask}>
                  {address?.displayName}, {address?.postcode}
                </span>
              </strong>
            </h5>
            <NsTitle title="Welcome back" />
            <p data-testid="expired-message">It looks like your quote has now expired. To make sure we offer you the best tariffs with the most up-to-date prices, please confirm your details below and we’ll get you a new one.</p>
          </NsContent>
          <EnergyHelp shouldShow={true}/>
        </NsColumn>
        <NsPrimaryCta onClick={handleNext}>Get a new quote</NsPrimaryCta>
        <MoreInformation/>
        <DirectDebitPromotionExpander shouldShow={true}/>
      </NsPanel>
    </>
  );
}

export default QuoteExpiredContent;